import React from 'react';
import ReactDOM from 'react-dom';
import './js/textImageSlider';
import './js/homepageSlider';
import './js/colorGroupSlider';
import './js/bigProjectsSlider';
import './js/colorsSlider';
import './js/storeSwitcher';
import './js/compare';
import './js/gallery';
import './js/brands';
import './js/blog';
import './js/lpExpiration';
import './js/remotes';
import './js/storePreviewModal';
import './js/header';
import './js/alpine-components';
import './js/references';
import './js/mobile-swiper';
import './js/locations';
import './js/dynamic-grid';
import './js/media-swiper';
import './js/history-swiper';
import './js/tableSlider';
import './js/detail';
import './js/catalog-gallery';
import './js/pelmet';
import './js/comparison';
import './js/categories';
import './js/delivery-popup';
import './js/refererence-gallery-swiper';
import './js/reviewsSwiper';

import Form from "./components/Form";
import CareerForm from "./components/CareerForm";
import smoothscroll from 'smoothscroll-polyfill';
import DemandForm from "./components/DemandForm";
import BannerDiscount from "./components/BannerDiscount";

const { WOW } = require('wowjs');

smoothscroll.polyfill();
document.addEventListener("DOMContentLoaded", () => {
	let doc = document;
	let body = doc.querySelector('body');
	let html = doc.querySelector('html');
	let header = doc.querySelector('header');
	let mobileMenuButton = doc.getElementById('mobile-menu-switch');
	let closeMobileMenu = doc.getElementById('close-mobile-menu');

	var wow = new WOW({
		boxClass: 'wow',      // animated element css class (default is wow)
		animateClass: 'animate__animated', // animation css class (default is animated)
		offset: 150,          // distance to the element when triggering the animation (default is 0)
		mobile: true,       // trigger animations on mobile devices (default is true)
		live: true,       // act on asynchronously loaded content (default is true)
		callback: null,
		scrollContainer: null // optional scroll container selector, otherwise use window
	});
	wow.init();

	window.addEventListener("scroll", function (e) {
		let items = document.querySelectorAll('.product-breadcrumbs a');
		if (items.length > 0) {
			let activeItems = [];
			items.forEach((item) => {
				const target = item.getAttribute('href');
				const targetElement = document.querySelector(target);
				if (targetElement && 300 > targetElement.getBoundingClientRect().top) {
					activeItems.push(target);
				} else {
					item.classList.remove('active');
				}
			});

			activeItems.map((href) => {
				let activeItem = document.querySelector('.product-breadcrumbs a[href="' + href + '"]');
				if (activeItem) {
					activeItem.classList.remove('active');
				}
			})

			let activeItemHref = activeItems[activeItems.length - 1];
			if (activeItemHref) {
				let activeItem = document.querySelector('.product-breadcrumbs a[href="' + activeItemHref + '"]');
				if (activeItem) {
					activeItem.classList.add('active');
				}
			}
		}
	});

	if (mobileMenuButton) {
		mobileMenuButton.addEventListener('click', () => {
			body.classList.add('opened-mobile-menu');
			html.classList.add('overflow-hidden');
		});
	}

	if (closeMobileMenu) {
		closeMobileMenu.addEventListener('click', () => {
			body.classList.remove('opened-mobile-menu');
			html.classList.remove('overflow-hidden');
		});
	}

	let faqToggler = doc.getElementById('faq-toggler');
	if (faqToggler) {
		faqToggler.addEventListener('click', () => {
			doc.querySelector('.faq').classList.add('faq-open');
			faqToggler.remove();
		})
	}
	let faqItems = doc.querySelectorAll('.faq__item');
	if (faqItems.length > 0) {
		faqItems.forEach((faqItem) => {
			faqItem.querySelector('.faq-open-answer').addEventListener('click', () => {
				faqItem.classList.toggle('open');
			})
		})
	}

	let similarProductsToggler = doc.getElementById('similar-products-toggler');
	if (similarProductsToggler) {
		similarProductsToggler.addEventListener('click', () => {
			doc.querySelector('.similar-products').classList.add('similar-products-open');
			similarProductsToggler.remove();
		})
	}


	let subMenuToggler = doc.querySelectorAll('.has-sub-menu > a');
	if (subMenuToggler) {

		subMenuToggler.forEach((toggler) => {
			toggler.addEventListener('click', (e) => {
				e.preventDefault();
				toggler.parentElement.classList.toggle('opened');
			})
		})
	}

	let memberListToggler = doc.querySelectorAll('.member-list-toggler');
	if (memberListToggler) {
		memberListToggler.forEach((toggler) => {
			toggler.addEventListener('click', () => {
				let list = toggler.parentNode.parentNode.querySelector('.list-members');
				list.classList.toggle('open');
				if (list.classList.contains('open')) {
					toggler.textContent = 'Weniger anzeigen';
				} else {
					toggler.textContent = 'Alle Kontakte';
				}
			})
		})
	}


	let tabs = doc.querySelector('.tabs');
	if (tabs) {
		let tabNavItems = tabs.querySelectorAll('.tabs__nav li');
		let elems = tabs.querySelectorAll('.tabs__item');

		if (tabNavItems.length > 0) {
			tabNavItems[0].classList.add('active');
		}
		if (elems.length > 0) {
			elems[0].classList.add('active');
		}
		tabNavItems.forEach((tabItem) => {
			tabItem.addEventListener('click', () => {
				let target = tabItem.getAttribute('data-target');
				[].forEach.call(elems, function (el) {
					el.classList.remove('active');
				});
				[].forEach.call(tabNavItems, function (el) {
					el.classList.remove('active');
				});
				tabs.querySelector(target).classList.add('active');
				tabItem.classList.add('active');
			})
		})
	}

	let discountBanners = doc.querySelectorAll('.discount-banner')
	if (discountBanners.length > 0) {
		discountBanners.forEach((element) => {
			const title = element.getAttribute('data-title');
			const button = element.getAttribute('data-button');
			const date = element.getAttribute('data-date');
			const url = element.getAttribute('data-url');

			ReactDOM.render(<BannerDiscount title={title} button={button} date={date} url={url} />, element);
		});
	}

	let formElement = doc.querySelector('#form');
	if (formElement) {
		ReactDOM.render(<Form
            stores={JSON.parse(formElement.getAttribute('data-stores'))}
			categoryId={formElement.getAttribute('data-category-id')}
			productId={formElement.getAttribute('data-product-id')}
            storeId={formElement.getAttribute('data-store-id')}
			isSubsidy={formElement.getAttribute('data-is-subsidy')}
		/>, formElement);
	}

	let careerFormElement = doc.querySelector('#career-form');
	if (careerFormElement) {
		ReactDOM.render(<CareerForm careerId={careerFormElement.getAttribute('data-career-id')} />, careerFormElement);
	}

	let demandFormElement = doc.querySelector('#demand-form');
	if (demandFormElement) {
		ReactDOM.render(<DemandForm
			tree={JSON.parse(demandFormElement.getAttribute('data-tree'))} />, demandFormElement);
	}

	let anchors = doc.querySelectorAll('.slideTo');
	if (anchors) {
		[].forEach.call(anchors, function (anchor) {
			anchor.addEventListener('click', (e) => {
				e.preventDefault();
				let element = doc.querySelector(anchor.getAttribute('href'));
				let header = doc.querySelector('header');
				window.scroll({
					top: element.getBoundingClientRect().top + window.scrollY - header.clientHeight,
					behavior: 'smooth'
				});
			})
		});
	}

	let btnShare = document.querySelectorAll('.btn-share');
	if (btnShare) {
		[].forEach.call(btnShare, function (btn) {
			btn.addEventListener('click', (e) => {
				let width = 575,
					height = 400,
					left = (window.innerWidth - width) / 2,
					top = (window.innerHeight - height) / 2,
					url = e.currentTarget.href,
					opts = 'status=1' +
						',width=' + width +
						',height=' + height +
						',top=' + top +
						',left=' + left;
				window.open(url, 'twitter', opts);
				e.preventDefault();
			})
		});

	}

	let showTimeline = document.getElementById('show-full-timeline');
	if (showTimeline) {
		showTimeline.addEventListener('click', () => {
			let timeline = document.querySelector('.timeline');
			timeline.classList.toggle('open');

			if (timeline.classList.contains('open')) {
				showTimeline.textContent = 'Weniger aus der Geschichte anzeigen';
			} else {
				showTimeline.textContent = 'Mehr aus der Geschichte anzeigen';
			}

		});
	}

	let patentsSelect = document.querySelector('#select-patenty select');
	if (patentsSelect) {
		patentsSelect.addEventListener('change', (e) => {
			let header = doc.querySelector('header');
			let element = document.querySelector('#patent-' + e.target.value);
			if (element) {
				window.scroll({
					top: element.getBoundingClientRect().top + window.scrollY - header.clientHeight,
					behavior: 'smooth'
				});
			}
		})
	}

	const productDescription = document.querySelector('.product-detail-header__description');
	if (productDescription) {
		if (productDescription.clientHeight > 300) {
			productDescription.classList.add('overflow-text-hidden');
		}

		const showMoreButton = document.getElementById('show-more-description');
		if (showMoreButton) {
			showMoreButton.addEventListener('click', (e) => {
				e.preventDefault();
				productDescription.classList.remove('overflow-text-hidden');
			})
		}
	}

	const dropdownMenuA = document.querySelectorAll('.dropdown-menu a');
	dropdownMenuA.forEach((item) => {
		item.addEventListener('mouseover', () => {
			const tooltip = item.querySelector('.tooltip');
			let dropdownMenuHeight = item.closest('.dropdown-menu').getBoundingClientRect().height;
			let top = item.getBoundingClientRect().top - header.clientHeight;
			if (top + 200 > dropdownMenuHeight) {
				top = top - 185;
			}

			if (top < 0) {
				top = 0;
			}

			let left = item.getBoundingClientRect().left + item.getBoundingClientRect().width + 10;

			tooltip.style.left = left + 'px';
			tooltip.style.top = top + 'px';
		});
	})

}, "DOMContentLoaded");
